import { getCookieValue, setCookie } from '../helpers/cookie';

export default function toggleCookieBanner() {
  const cookieBanner = document.getElementById('cookie-banner');
  const closeBtn = document.getElementById('cookie-banner-close');

  const EUROPEAN_COUNTRY_CODES = [
    'AL',
    'AD',
    'AT',
    'BY',
    'BE',
    'BA',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'EL',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IS',
    'IE',
    'IT',
    'LV',
    'LI',
    'LT',
    'LU',
    'MT',
    'MD',
    'MC',
    'ME',
    'NL',
    'MK',
    'NO',
    'PL',
    'PT',
    'RO',
    'RU',
    'SM',
    'RS',
    'SK',
    'SI',
    'ES',
    'SE',
    'CH',
    'TR',
    'UA',
    'GB',
    'UK',
  ];

  if (
    window.siteInfo
    && EUROPEAN_COUNTRY_CODES.includes(window.siteInfo.country)
    && cookieBanner
  ) {
    if (!getCookieValue('isCookieBannerClosed')) {
      cookieBanner.classList.add('show');
      closeBtn.addEventListener('click', () => {
        cookieBanner.classList.remove('show');
        setCookie('isCookieBannerClosed', true, 365);
      });
    }
  }
}
